import { render, staticRenderFns } from "./EditBlockTabBackground.vue?vue&type=template&id=d4c750ec&"
import script from "./EditBlockTabBackground.vue?vue&type=script&lang=js&"
export * from "./EditBlockTabBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports